module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right-panel md-elevation-1 md-scrollbar md-theme-default",
    attrs: {
      "id": "itinerary"
    }
  }, [_c('div', {
    staticClass: "entity-card"
  }, [_c('div', {
    staticClass: "md-layout-row entity-card-head"
  }, [_c('div', {
    staticClass: "md-layout-item entity-head-left"
  }, [(_vm.$route.params.id) ? _c('span', [_vm._v(_vm._s('Маршрутный лист №' + _vm.$route.params.id))]) : _vm._e(), (_vm.result.status) ? _c('div', {
    staticClass: "status",
    style: ('color: ' + (_vm.result.status.color ? _vm.result.status.color : 'balck') + ';')
  }, [_vm._v(_vm._s(_vm.result.status.message))]) : _vm._e(), (_vm.$route.params.id && _vm.$route.params.id != 'new') ? _c('md-button', {
    staticClass: "md-icon-button md-dense close small full-price-btn",
    on: {
      "click": function($event) {
        _vm.updateRoutelistStatus(_vm.$route.params.id)
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-sync-alt"
  }), _c('md-tooltip', {
    attrs: {
      "md-direction": "bottom",
      "md-delay": "500"
    }
  }, [_vm._v("Обновить статус МЛ")])], 1) : _vm._e(), (_vm.canAcceptAuto) ? _c('z-button', {
    staticClass: "acceptauto",
    on: {
      "click": function($event) {
        _vm.acceptAuto()
      }
    }
  }, [_vm._v("Принять машину на складе")]) : _vm._e()], 1), _c('div', {
    staticClass: "md-layout-item entity-head-center"
  }), _c('div', {
    staticClass: "md-layout-item entity-head-right"
  }, [(_vm.canSave) ? _c('md-button', {
    staticClass: "md-primary md-icon-button md-dense close small",
    on: {
      "click": _vm.save
    }
  }, [_c('md-icon', [_vm._v("check")]), _c('md-tooltip', {
    attrs: {
      "md-direction": "bottom",
      "md-delay": "500"
    }
  }, [_vm._v("Сохранить")])], 1) : _vm._e(), _c('md-button', {
    staticClass: "md-icon-button md-dense close small",
    on: {
      "click": _vm.back
    }
  }, [_c('md-icon', [_vm._v("close")]), _c('md-tooltip', {
    attrs: {
      "md-direction": "bottom",
      "md-delay": "500"
    }
  }, [_vm._v("Отменить")])], 1)], 1)]), _c('div', {
    directives: [{
      name: "loader-overlay",
      rawName: "v-loader-overlay",
      value: (_vm.progress),
      expression: "progress"
    }],
    staticClass: "entity-card-body"
  }, [_c('flex-tabs', {
    attrs: {
      "tabs": _vm.tabs,
      "min": "min"
    },
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }), (_vm.activeTab === 'tab-comments' && _vm.routeList && _vm.routeList.id && _vm.routeList.id != 'new') ? _c('div', {
    staticClass: "md-layout-item entity-head-tight"
  }, [_c('comments-and-logs', {
    attrs: {
      "entity_id": _vm.routeList.id,
      "entity": "deals_routelist",
      "module": "deals"
    }
  })], 1) : _vm._e(), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab === 'tab-routelist'),
      expression: "activeTab === 'tab-routelist'"
    }],
    staticClass: "md-layout-item entity-head-tight"
  }, [_c('div', {
    staticClass: "md-body-1"
  }, [_c('div', {
    staticClass: "sum-data-title"
  }, [_vm._v("Суммарная информация по выбранным грузам")]), _c('div', {
    staticClass: "sum-data"
  }, [_c('div', {
    staticClass: "sum-data-item",
    attrs: {
      "md-with-hover": "md-with-hover"
    }
  }, [_c('span', [_vm._v(_vm._s('Вec (кг): '))]), _c('b', [_vm._v(_vm._s(_vm.round(_vm.result.weight)))])]), _c('div', {
    staticClass: "sum-data-item",
    attrs: {
      "md-with-hover": "md-with-hover"
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s('Объём (м<sup>3</sup>): ')
    }
  }), _c('b', [_vm._v(_vm._s(_vm.round(_vm.result.volume)))])]), _c('div', {
    staticClass: "sum-data-item",
    attrs: {
      "md-with-hover": "md-with-hover"
    }
  }, [_c('span', [_vm._v(_vm._s('Мест: '))]), _c('b', [_vm._v(_vm._s(_vm.result.seats))])])]), _c('div', {
    staticClass: "direction-container"
  }, [(!_vm.canEditFouteList) ? _c('span', {
    staticClass: "md-subheading"
  }, [_vm._v("Маршрутный лист находится в работе, редактирование недоступно")]) : _vm._e(), _c('div', {
    staticClass: "direction-area__container"
  }, [_c('div', {
    staticClass: "direction-area"
  }, [_c('z-big-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        'required': true
      }),
      expression: "{'required': true}"
    }],
    attrs: {
      "label": "Тип перевозки",
      "name": "forward_type",
      "id": "forward_type",
      "required": true,
      "disabled": !_vm.canEditFouteList,
      "error": _vm.errors.first('forward_type'),
      "icon": "<i class=\"far fa-clipboard\"></i>"
    },
    model: {
      value: (_vm.result.forward_type),
      callback: function($$v) {
        _vm.$set(_vm.result, "forward_type", $$v)
      },
      expression: "result.forward_type"
    }
  }, _vm._l((_vm.types), function(item) {
    return _c('z-select-item', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.value
      },
      on: {
        "click": _vm.clearData
      }
    })
  }))], 1), _c('div', {
    staticClass: "direction-area"
  }, [_c('z-big-date', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "label": ((parseInt(_vm.result.forward_type) === 1) ? 'Дата экспедирования' : 'Дата перевозки'),
      "id": "date",
      "name": "date",
      "required": true,
      "disabled": !_vm.canEditFouteList,
      "error": _vm.errors.first('date')
    },
    model: {
      value: (_vm.result.date),
      callback: function($$v) {
        _vm.$set(_vm.result, "date", $$v)
      },
      expression: "result.date"
    }
  })], 1), (_vm.result && _vm.result.forward_type) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (parseInt(_vm.result.forward_type) === 2),
      expression: "parseInt(result.forward_type) === 2"
    }],
    staticClass: "direction-area"
  }, [(_vm.fromStocks && _vm.fromStocks.length && parseInt(_vm.result.forward_type) === 2) ? _c('z-big-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        'required': (parseInt(_vm.result.forward_type) === 2)
      }),
      expression: "{'required': (parseInt(result.forward_type) === 2)}"
    }],
    attrs: {
      "id": "from_stock_id",
      "name": "from_stock_id",
      "label": "Склад отправления",
      "required": true,
      "disabled": !_vm.canEditFouteList,
      "icon": "<i class=\"fas fa-warehouse\"></i>",
      "error": _vm.errors.first('from_stock_id'),
      "data-vv-as": ' '
    },
    model: {
      value: (_vm.result.from_stock_id),
      callback: function($$v) {
        _vm.$set(_vm.result, "from_stock_id", $$v)
      },
      expression: "result.from_stock_id"
    }
  }, _vm._l((_vm.fromStocks), function(item) {
    return _c('z-select-item', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.name
      },
      on: {
        "click": _vm.clearFromData
      }
    })
  })) : _vm._e(), (_vm.responsiblesFrom && _vm.responsiblesFrom.length && parseInt(_vm.result.forward_type) === 2) ? _c('z-big-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        'required': (parseInt(_vm.result.forward_type) === 2)
      }),
      expression: "{'required': (parseInt(result.forward_type) === 2)}"
    }],
    attrs: {
      "label": "Кладовщик в пункте отправления",
      "id": "from_storekeeper_id",
      "name": "from_storekeeper_id",
      "required": true,
      "disabled": !_vm.canEditFouteList,
      "error": _vm.errors.first('from_storekeeper_id'),
      "data-vv-as": ' ',
      "icon": "<i class=\"fas fa-people-carry\"></i>"
    },
    model: {
      value: (_vm.result.from_storekeeper_id),
      callback: function($$v) {
        _vm.$set(_vm.result, "from_storekeeper_id", $$v)
      },
      expression: "result.from_storekeeper_id"
    }
  }, _vm._l((_vm.responsiblesFrom), function(item) {
    return _c('z-select-item', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.login
      }
    })
  })) : _vm._e(), (_vm.result.from_stock_id && _vm.drivers && _vm.drivers.length && parseInt(_vm.result.forward_type) === 2) ? _c('z-big-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        'required': (parseInt(_vm.result.forward_type) === 2)
      }),
      expression: "{'required': (parseInt(result.forward_type) === 2)}"
    }],
    attrs: {
      "label": "Водитель",
      "id": "driver_id",
      "name": "driver_id",
      "required": true,
      "disabled": !_vm.canEditFouteList,
      "error": _vm.errors.first('driver_id'),
      "data-vv-as": ' ',
      "icon": "<i class=\"fa fa-user\"></i>"
    },
    model: {
      value: (_vm.result.driver_id),
      callback: function($$v) {
        _vm.$set(_vm.result, "driver_id", $$v)
      },
      expression: "result.driver_id"
    }
  }, _vm._l((_vm.drivers), function(item) {
    return _c('z-select-item', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.label
      }
    })
  })) : _vm._e()], 1) : _vm._e(), (_vm.result && _vm.result.forward_type) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (parseInt(_vm.result.forward_type) === 2),
      expression: "parseInt(result.forward_type) === 2"
    }],
    staticClass: "direction-area"
  }, [(_vm.toStocks && _vm.toStocks.length && parseInt(_vm.result.forward_type) === 2) ? _c('z-big-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        'required': (parseInt(_vm.result.forward_type) === 2)
      }),
      expression: "{'required': (parseInt(result.forward_type) === 2)}"
    }],
    attrs: {
      "id": "to_stock_id",
      "name": "to_stock_id",
      "label": "Склад назначения",
      "required": true,
      "disabled": !_vm.canEditFouteList,
      "error": _vm.errors.first('to_stock_id'),
      "data-vv-as": ' ',
      "icon": "<i class=\"fas fa-warehouse\"></i>"
    },
    model: {
      value: (_vm.result.to_stock_id),
      callback: function($$v) {
        _vm.$set(_vm.result, "to_stock_id", $$v)
      },
      expression: "result.to_stock_id"
    }
  }, _vm._l((_vm.toStocks), function(item) {
    return _c('z-select-item', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.name
      },
      on: {
        "click": _vm.clearToData
      }
    })
  })) : _vm._e(), (_vm.responsiblesTo && _vm.responsiblesTo.length && parseInt(_vm.result.forward_type) === 2) ? _c('z-big-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        'required': (parseInt(_vm.result.forward_type) === 2)
      }),
      expression: "{'required': (parseInt(result.forward_type) === 2)}"
    }],
    attrs: {
      "id": "to_storekeeper_id",
      "name": "to_storekeeper_id",
      "label": "Кладовщик в пункте назначения",
      "required": true,
      "disabled": !_vm.canEditFouteList,
      "error": _vm.errors.first('to_storekeeper_id'),
      "data-vv-as": ' ',
      "icon": "<i class=\"fas fa-people-carry\"></i>"
    },
    model: {
      value: (_vm.result.to_storekeeper_id),
      callback: function($$v) {
        _vm.$set(_vm.result, "to_storekeeper_id", $$v)
      },
      expression: "result.to_storekeeper_id"
    }
  }, _vm._l((_vm.responsiblesTo), function(item) {
    return _c('z-select-item', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.login
      }
    })
  })) : _vm._e(), (_vm.responsiblesTo && _vm.responsiblesTo.length && parseInt(_vm.result.forward_type) === 2) ? _c('z-big-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        'required': (parseInt(_vm.result.forward_type) === 2)
      }),
      expression: "{'required': (parseInt(result.forward_type) === 2)}"
    }],
    attrs: {
      "id": "to_chief_id",
      "name": "to_chief_id",
      "label": "Ответственный за прием машины в пункте назначения",
      "required": true,
      "disabled": !_vm.canEditFouteList,
      "error": _vm.errors.first('to_chief_id'),
      "data-vv-as": ' ',
      "icon": "<i class=\"fas fa-user-check\"></i>"
    },
    model: {
      value: (_vm.result.to_chief_id),
      callback: function($$v) {
        _vm.$set(_vm.result, "to_chief_id", $$v)
      },
      expression: "result.to_chief_id"
    }
  }, _vm._l((_vm.responsiblesTo), function(item) {
    return _c('z-select-item', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.login
      }
    })
  })) : _vm._e()], 1) : _vm._e(), (_vm.result && _vm.result.forward_type) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (parseInt(_vm.result.forward_type) === 1),
      expression: "parseInt(result.forward_type) === 1"
    }],
    staticClass: "direction-area full-width"
  }, [(_vm.stocks && _vm.stocks.length && parseInt(_vm.result.forward_type) === 1) ? _c('z-big-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        'required': (parseInt(_vm.result.forward_type) === 1)
      }),
      expression: "{'required': (parseInt(result.forward_type) === 1)}"
    }],
    attrs: {
      "name": "stock_id",
      "id": "stock_id",
      "label": "Склад экспедирования",
      "required": true,
      "disabled": !_vm.canEditFouteList,
      "error": _vm.errors.first('stock_id'),
      "data-vv-as": ' ',
      "icon": "<i class=\"fas fa-warehouse\"></i>"
    },
    model: {
      value: (_vm.result.stock_id),
      callback: function($$v) {
        _vm.$set(_vm.result, "stock_id", $$v)
      },
      expression: "result.stock_id"
    }
  }, _vm._l((_vm.stocks), function(item) {
    return _c('z-select-item', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.name
      },
      on: {
        "click": _vm.clearForwardData
      }
    })
  })) : _vm._e()], 1) : _vm._e(), (_vm.result && _vm.result.forward_type) ? _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (parseInt(_vm.result.forward_type) === 1),
      expression: "parseInt(result.forward_type) === 1"
    }],
    staticClass: "direction-area"
  }, [(_vm.forwarders && _vm.forwarders.length && parseInt(_vm.result.forward_type) === 1) ? _c('z-big-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        'required': (parseInt(_vm.result.forward_type) === 1)
      }),
      expression: "{'required': (parseInt(result.forward_type) === 1)}"
    }],
    attrs: {
      "id": "forwarder_id",
      "name": "forwarder_id",
      "label": "Ответственный экспедитор",
      "required": true,
      "disabled": !_vm.canEditFouteList,
      "data-vv-as": ' ',
      "error": _vm.errors.first('forwarder_id'),
      "icon": "<i class=\"fas fa-truck-loading\"></i>"
    },
    model: {
      value: (_vm.result.forwarder_id),
      callback: function($$v) {
        _vm.$set(_vm.result, "forwarder_id", $$v)
      },
      expression: "result.forwarder_id"
    }
  }, _vm._l((_vm.forwarders), function(item) {
    return _c('z-select-item', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.login
      }
    })
  })) : _vm._e()], 1) : _vm._e(), (_vm.result && _vm.result.forward_type && parseInt(_vm.result.forward_type) === 1) ? _c('div', {
    staticClass: "direction-area"
  }, [(_vm.storekeepres && _vm.storekeepres.length && parseInt(_vm.result.forward_type) === 1) ? _c('z-big-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        'required': (parseInt(_vm.result.forward_type) === 1)
      }),
      expression: "{'required': (parseInt(result.forward_type) === 1)}"
    }],
    attrs: {
      "id": "storekeeper_id",
      "name": "storekeeper_id",
      "label": "Ответственный кладовщик",
      "required": true,
      "disabled": !_vm.canEditFouteList,
      "error": _vm.errors.first('storekeeper_id'),
      "data-vv-as": ' ',
      "icon": "<i class=\"fas fa-people-carry\"></i>"
    },
    model: {
      value: (_vm.result.storekeeper_id),
      callback: function($$v) {
        _vm.$set(_vm.result, "storekeeper_id", $$v)
      },
      expression: "result.storekeeper_id"
    }
  }, _vm._l((_vm.storekeepres), function(item) {
    return _c('z-select-item', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.login
      }
    })
  })) : _vm._e()], 1) : _vm._e()]), _c('div', {
    staticClass: "direction-area__container"
  }, [(_vm.vansAndTractors && _vm.vansAndTractors.length) ? _c('div', {
    staticClass: "direction-area"
  }, [_c('z-big-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        'required': true
      }),
      expression: "{'required': true}"
    }],
    attrs: {
      "id": "auto_id",
      "name": "auto_id",
      "label": "Автомобиль",
      "required": true,
      "disabled": !_vm.canEditFouteList,
      "error": _vm.errors.first('auto_id'),
      "data-vv-as": ' ',
      "icon": "<i class=\"fas fa-truck\"></i>"
    },
    model: {
      value: (_vm.result.auto_id),
      callback: function($$v) {
        _vm.$set(_vm.result, "auto_id", $$v)
      },
      expression: "result.auto_id"
    }
  }, _vm._l((_vm.vansAndTractors), function(item) {
    return _c('z-select-item', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.label
      }
    })
  }))], 1) : _vm._e(), (_vm.trailers && _vm.trailers.length) ? _c('div', {
    staticClass: "direction-area"
  }, [_c('z-big-multy-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        'required': false
      }),
      expression: "{'required': false}"
    }],
    attrs: {
      "id": "trailers",
      "name": "trailers",
      "label": "Прицеп",
      "required": false,
      "disabled": !_vm.canEditFouteList,
      "error": _vm.errors.first('trailers'),
      "data-vv-as": ' ',
      "icon": "<i class=\"fas fa-trailer\"></i>"
    },
    model: {
      value: (_vm.result.trailers),
      callback: function($$v) {
        _vm.$set(_vm.result, "trailers", $$v)
      },
      expression: "result.trailers"
    }
  }, _vm._l((_vm.trailers), function(item) {
    return _c('z-multy-select-item', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.label,
        "selected": (_vm.result.trailers && (_vm.result.trailers.indexOf(item.id) + 1)) ? true : false
      }
    })
  }))], 1) : _vm._e(), (_vm.agents && _vm.agents.length) ? _c('div', {
    staticClass: "direction-area"
  }, [_c('z-big-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        'required': true
      }),
      expression: "{'required': true}"
    }],
    attrs: {
      "id": "agent_id",
      "name": "agent_id",
      "label": "Перевозчик",
      "required": true,
      "disabled": !_vm.canEditFouteList,
      "error": _vm.errors.first('agent_id'),
      "data-vv-as": ' ',
      "icon": "<i class=\"fas fa-user-tie\"></i>"
    },
    model: {
      value: (_vm.result.agent_id),
      callback: function($$v) {
        _vm.$set(_vm.result, "agent_id", $$v)
      },
      expression: "result.agent_id"
    }
  }, _vm._l((_vm.agents), function(item) {
    return _c('z-select-item', {
      key: item.id,
      attrs: {
        "value": item.id,
        "label": item.label
      }
    })
  }))], 1) : _vm._e()])]), (_vm.errors && _vm.errors.items && _vm.errors.items.length) ? _c('div', {
    staticClass: "freight-list-title error"
  }, [_c('span', {
    staticClass: "error"
  }, [_vm._v("В параметрах маршрутного листа есть ошибки, пожалуйста исправьте их")])]) : _vm._e(), (!_vm.selectedFreights || !_vm.selectedFreights.length) ? _c('div', {
    staticClass: "freight-list-title error"
  }, [_c('span', {
    staticClass: "error"
  }, [_vm._v("Грузы не выбраны")])]) : _vm._e(), (_vm.newFreights && _vm.newFreights.length) ? _c('toggle-card', {
    attrs: {
      "visibility": true,
      "heading": ("Выбранные грузы " + (_vm.calcDimensionsStr(_vm.newFreights, _vm.newFreights.length)))
    }
  }, [(_vm.newFreights && _vm.newFreights.length) ? _c('div', {
    staticClass: "freight-list"
  }, _vm._l((_vm.newFreights), function(freight, i) {
    return _c('div', {
      key: ('zrl-' + i + '-' + freight.id)
    }, [_c('ZRLFreight', {
      attrs: {
        "freight": freight,
        "error": (_vm.freightsErrors[freight.id]) ? _vm.freightsErrors[freight.id] : null,
        "warning": (_vm.freightsWarnings[freight.id]) ? _vm.freightsWarnings[freight.id] : null,
        "doomMarkup": _vm.doomMarkup,
        "show-remove": true,
        "showForwardTypeLabel": (parseInt(_vm.result.forward_type) === 1 ? true : false),
        "forward-method": ((freight.current_forward_method) ? parseInt(freight.current_forward_method) : _vm.getFreightForwardMethod(freight))
      },
      on: {
        "remove": function($event) {
          _vm.removeFreight(freight)
        }
      }
    }), _c('div', {
      staticClass: "freight-list__intermediate-dimensions",
      domProps: {
        "innerHTML": _vm._s(_vm.calcDimensionsStr(_vm.newFreights, i))
      }
    })], 1)
  })) : _vm._e()]) : _vm._e(), (_vm.notCompletedFreights && _vm.notCompletedFreights.length) ? _c('toggle-card', {
    attrs: {
      "visibility": true,
      "heading": ("Не обработанные грузы " + (_vm.calcDimensionsStr(_vm.notCompletedFreights, _vm.notCompletedFreights.length)))
    }
  }, [(_vm.hasFreightsErrors) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("(В списке грузов есть ошибки. Проверьте список грузов.)")]) : _vm._e(), (_vm.notCompletedFreights && _vm.notCompletedFreights.length) ? _c('div', {
    staticClass: "freight-list"
  }, _vm._l((_vm.notCompletedFreights), function(freight, i) {
    return _c('div', {
      key: ('zrl-' + i + '-' + freight.id)
    }, [_c('ZRLFreight', {
      attrs: {
        "freight": freight,
        "error": (_vm.freightsErrors[freight.id]) ? _vm.freightsErrors[freight.id] : null,
        "warning": (_vm.freightsWarnings[freight.id]) ? _vm.freightsWarnings[freight.id] : null,
        "doomMarkup": _vm.doomMarkup,
        "show-remove": true,
        "showForwardTypeLabel": (parseInt(_vm.result.forward_type) === 1 ? true : false),
        "forward-method": ((freight.current_forward_method) ? parseInt(freight.current_forward_method) : _vm.getFreightForwardMethod(freight))
      },
      on: {
        "remove": function($event) {
          _vm.removeFreight(freight)
        }
      }
    }), _c('div', {
      staticClass: "freight-list__intermediate-dimensions",
      domProps: {
        "innerHTML": _vm._s(_vm.calcDimensionsStr(_vm.notCompletedFreights, i))
      }
    })], 1)
  })) : _vm._e()]) : _vm._e(), (_vm.completedFreights && _vm.completedFreights.length) ? _c('toggle-card', {
    attrs: {
      "visibility": true,
      "heading": ("Обработанные грузы " + (_vm.calcDimensionsStr(_vm.completedFreights, _vm.completedFreights.length)))
    }
  }, [(_vm.completedFreights && _vm.completedFreights.length) ? _c('div', {
    staticClass: "freight-list"
  }, _vm._l((_vm.completedFreights), function(freight, i) {
    return _c('div', {
      key: ('zrl-' + i + '-' + freight.id)
    }, [_c('ZRLFreight', {
      attrs: {
        "freight": freight,
        "error": (_vm.freightsErrors[freight.id]) ? _vm.freightsErrors[freight.id] : null,
        "warning": (_vm.freightsWarnings[freight.id]) ? _vm.freightsWarnings[freight.id] : null,
        "doomMarkup": _vm.doomMarkup,
        "show-remove": true,
        "showForwardTypeLabel": (parseInt(_vm.result.forward_type) === 1 ? true : false),
        "forward-method": ((freight.current_forward_method) ? parseInt(freight.current_forward_method) : _vm.getFreightForwardMethod(freight))
      },
      on: {
        "remove": function($event) {
          _vm.removeFreight(freight)
        }
      }
    }), _c('div', {
      staticClass: "freight-list__intermediate-dimensions",
      domProps: {
        "innerHTML": _vm._s(_vm.calcDimensionsStr(_vm.completedFreights, i))
      }
    })], 1)
  })) : _vm._e()]) : _vm._e()], 1)])], 1), _c('div', {
    staticClass: "entity-card-footer"
  }, [((_vm.$route.params.id && _vm.$route.params.id != 'new')) ? _c('md-button', {
    staticClass: "md-primary small",
    on: {
      "click": _vm.printDoc
    }
  }, [_vm._v("Распечатать")]) : _vm._e()], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5fb2509a","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/deals/views/ItineraryFreights.vue
// module id = 1163
// module chunks = 0